import React, { Fragment } from "react";
import classes from "./Layout.module.css";
import Toolbar from '../Navigation/Toolbar/Toolbar'
import Sidebar from '../Navigation/Sidebar/Sidebar'

const layout = (props) => (
    <Fragment>
        <Sidebar {...props}/>
        <Toolbar />
        <main className={classes.pageContent}>
            {props.children}
        </main>
    </Fragment>
);

export default layout;